import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const KioskIdMobile = () => {
  const { kioskId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('Kiosk ID', kioskId);

    if (!window.localStorage) {
      alert('no local storage');
    }

    if (kioskId) {
      localStorage.setItem('device', 'mobile');
      localStorage.setItem('kiosk-id-quiz', kioskId);
    }

    if (!localStorage.getItem('kiosk-id-quiz')) {
      console.warn('No kiosk ID provided');
    }

    navigate('/');
  }, [kioskId, navigate]);
};

export default KioskIdMobile;
